import React, { Component } from 'react'
import "../stylesheets/navbar.css"

import logo from '../../aigenlogo.png'

export default class Navbar extends Component {
    render() {
        return (
            <div id="nav-container">
             <nav className="navbar">
                 <ul className="logo">
                    <img src={logo} alt="logo" width="50" ></img>
                 </ul>
                 <ul className="content">
                    <a  className="link"> <li><span className="fa fa-home"> Home</span></li></a>
                    <a className="link"> <li> <span className="fa fa-shopping-cart"> Products</span></li></a>
                    <a className="link"> <li><span className="fa fa-address-book"> Contact</span></li></a>
                    <a className="menu"><li><span className="fa fa-bars"></span></li></a>
                 </ul>
             </nav>
             
            </div>
        )
    }
}
